import { Button, Group, Modal, Stack, Text } from '@mantine/core'
import type { SeatingGroup } from '@/lib/seatingUtils'
import { getGroupLabel } from '@/lib/seatingUtils'

interface PromoteTestGuestModalProps {
  opened: boolean
  onClose: () => void
  group: SeatingGroup | null
  loading: boolean
  onConfirm: () => void
}

export function PromoteTestGuestModal({
  opened,
  onClose,
  group,
  loading,
  onConfirm,
}: PromoteTestGuestModalProps) {
  const label = group ? getGroupLabel(group) : ''

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Testnutzer promoten"
      size="md"
    >
      <Stack gap="md">
        <Text size="sm">
          Soll <strong>{label}</strong> zu einem echten Gast mit Zusage umgewandelt werden?
        </Text>
        <Text size="sm" c="dimmed">
          Der Testnutzer wird aus diesem Sitzplan entfernt und erscheint danach in der Gästeliste
          und in allen Sitzplan-Konfigurationen als normaler Gast. Die aktuelle Tischzuweisung
          bleibt in dieser Konfiguration erhalten.
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={loading}>
            Abbrechen
          </Button>
          <Button color="green" onClick={onConfirm} loading={loading}>
            Zu echtem Gast promoten
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
